module.exports = __webpack_public_path__ + "img/rang4.80adfac2.png";